import React, { useEffect, useRef, useState } from 'react';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Point from 'ol/geom/Point';
import { Feature } from 'ol';
import { fromLonLat } from 'ol/proj';
import Attribution from 'ol/control/Attribution';
import FullScreen from 'ol/control/FullScreen';
import Zoom from 'ol/control/Zoom';
import axios from 'axios';
import "./ContactMap.css";

const ContactMap = ({ publicData }) => {
  const [coordinates, setCoordinates] = useState(null);
  const [loading, setLoading] = useState(true);
  const mapElementRef = useRef(null);
  const mapRef = useRef(null);
  const markerLayerRef = useRef(null);

  // 1. Získání souřadnic
  useEffect(() => {
    const geocodeAddress = async (address) => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/map/geocode`, {
          params: { address }
        });
        if (response.data && response.data.length > 0) {
          const { lat, lon } = response.data[0];
          setCoordinates([parseFloat(lon), parseFloat(lat)]);
        }
      } catch (err) {
        console.error("Geokódování selhalo:", err);
      } finally {
        setLoading(false);
      }
    };

    const address = `${publicData.street} ${publicData.houseNumber}, ${publicData.city}, ${publicData.postalCode}, ${publicData.country}`;
    geocodeAddress(address);
  }, [publicData]);

  // 2. Inicializace mapy pouze jednou
  useEffect(() => {
    if (mapRef.current || !mapElementRef.current) return;

    const map = new Map({
      target: mapElementRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: fromLonLat([14.42076, 50.08804]), // Výchozí Praha
        zoom: 13,
      }),
      controls: [
        new Attribution({ collapsible: false }),
        new Zoom(),
        new FullScreen(),
      ],
    });

    // Vytvoření vrstvy pro marker
    const markerLayer = new VectorLayer({
      source: new VectorSource(),
    });

    map.addLayer(markerLayer);

    // Uložit reference
    mapRef.current = map;
    markerLayerRef.current = markerLayer;
  }, []);

  // 3. Přidání markeru po načtení souřadnic
  useEffect(() => {
    if (coordinates && markerLayerRef.current && mapRef.current) {
      const marker = new Feature({
        geometry: new Point(fromLonLat(coordinates)),
      });

      const source = new VectorSource({
        features: [marker],
      });

      markerLayerRef.current.setSource(source);
      mapRef.current.getView().setCenter(fromLonLat(coordinates));
      mapRef.current.getView().setZoom(15);
    }
  }, [coordinates]);

  return (
    <div style={{ width: '100%', height: '220px', position: 'relative'}} className='contact-map-zero-padding'>
      {loading && (
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: '#fff',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

        }}  className='contact-map-zero-padding'>
          <p>Načítání mapy…</p>
        </div>
      )}
      <div
        ref={mapElementRef}
        style={{ width: '100%', height: '100%' }}
         className='contact-map-zero-padding'
      />
    </div>
  );
};

export default ContactMap;